import {format, parseISO} from 'date-fns';

export const getIsoShortDateFromIsoLongDate = (value?: string | null) => {
	return value == null ? value : format(parseISO(value), 'yyyy-MM-dd');
};

export default getIsoShortDateFromIsoLongDate;
